<template>
    <div>
        <div class="app-block p-md m-md">
            <h3 class="heading-line title is-4 has-text-weight-light"><span :class="'school-title-'+schoolSlug">Documents</span>
            </h3>
            <div class="content app-documents">

                <div class="columns has-text-centered is-multiline">
                    <div class="column">
                        <h3 class="title has-text-weight-light"><strong>Pièce d'identité</strong></h3>
                        <div v-for="doc in application.documents" v-if="doc.document_type === 'identity-doc'"
                             :key="doc.id">
                            <span class="doc-filename"><a class="doc-remove" @click="deleteDocument(doc)"
                                                          v-if="!registered"><i
                                    class="fa fa-trash"></i></a> <a
                                    :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                    target="_blank">{{ doc.original_file_name }}</a></span>
                        </div>
                    </div>
                    <div class="column">
                        <h3 class="title has-text-weight-light"><strong>Diplômes/Notes</strong></h3>
                        <div v-for="doc in application.documents" v-if="doc.document_type === 'cursus-doc'"
                             :key="doc.id">
                            <span class="doc-filename"><a class="doc-remove" @click="deleteDocument(doc)"
                                                          v-if="!registered"><i
                                    class="fa fa-trash"></i></a> <a
                                    :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                    target="_blank">{{ doc.original_file_name }}</a></span>
                        </div>
                    </div>
                    <div class="column">
                        <h3 class="title has-text-weight-light"><strong>Autre</strong></h3>
                        <div v-for="doc in application.documents" v-if="doc.document_type === 'other-doc'"
                             :key="doc.id">
                            <span class="doc-filename"><a class="doc-remove" @click="deleteDocument(doc)"
                                                          v-if="!registered"><i
                                    class="fa fa-trash"></i></a> <a
                                    :href="'/api/candidate/document/'+doc.file_name+'?token='+user.token"
                                    target="_blank">{{ doc.original_file_name }}</a></span>
                        </div>
                    </div>
                </div>

                <div class="has-text-right">
                    <button class="button" @click="edit" v-if="!registered">
                        Modifier
                    </button>
                </div>

            </div>

        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'

    import api from 'services/candidate'

    export default {

        data () {
            return {}
        },
        computed: {
            registered () {
                return this.application.registration && this.application.registration.registered_candidate
            },
            ...mapState({
                user: 'auth',
            }),
        },
        props: {
            schoolSlug: { type: String },
            candidate: { type: Object },
            application: {type: Object},
        },
        methods: {
            ...mapActions({
                removeDoc: 'candidate/removeDocument'
            }),
            edit: function () {
                this.$emit('edit')
            },

            deleteDocument (file) {
                let docToRemove;
                api.removeDocument(file).then((result) => {

                    if (result.status === 200) {
                        this.application.documents.forEach(function (doc) {
                            if (file.id === doc.id) {
                                docToRemove = doc;
                            }
                        })
                        this.removeDoc(docToRemove)
                    }

                }).catch(e => {

                })
            }
        }
    }
</script>
